export default {
    props: ['show'],

    methods: {
        close: function () {
            this.$emit('close');
        }
    },

    mounted: function () {
        document.addEventListener("keydown", (e) => {
            if (this.show && e.keyCode == 27) {
                this.close();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/Shared/Modal/Modal.js